import { h } from 'preact';

const Header = () => (
    <header class="page-header container">
        <img class="page-header__logo" src="/assets/images/milliebeedoodles-logo.png" />
        <h1 class="page-header__title">Milliebeedoodles</h1>
        <a
            class="social-link social-link--facebook"
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.facebook.com/milliebeedoodles/"
        >
            <i class="fab fa-facebook-square" />
        </a>
        <a
            class="social-link social-link--instagram"
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.instagram.com/milliebeedoodles/"
        >
            <i class="fab fa-instagram" />
        </a>
        <a
            class="social-link social-link--tiktok"
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.tiktok.com/@milliebeedoodles/"
        >
            <i class="fab fa-tiktok"></i>
        </a>
    </header>
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js